<script setup lang="ts">
import { ref } from 'vue'
import { isObject, isString } from 'lodash'

const link = ref<HTMLDivElement>(null as unknown as HTMLDivElement)
const classes = ['outline-purpleCustom', 'outline', 'outline-3']
const props = defineProps<{
  customBackground?: boolean
  classCustom?: Record<string, boolean>
}>()

function onClick (ev: Event): void {
  const allHighlightedBlocks = document.getElementsByClassName('outline-purpleCustom')

  for (const block of allHighlightedBlocks) {
    if (!block.classList.contains('ignore-crd-block-click-event')) {
      block.classList.remove(...classes)
    }
  }

  link.value.classList.add(...classes)
}
</script>
<template>
  <div
    :class="{
      'p-4 rounded-md shadow flex gap-4 crd-block': true,
      'bg-white': !props.customBackground,
      [$attrs.class as string]: true,
      ...(isObject(props.classCustom) ? classCustom: {}),
    }"
    ref="link"
    @click="onClick"
  >
    <slot/>
  </div>
</template>
